import * as d3 from 'd3-selection'
import * as shape from 'd3-shape'
import arrowArc from 'arrow-arc'
import labels from './labels'
import * as colors from 'colors'

const decorations = (selection, innerArc, outerArc) => {
  selection.each(function (d) {
    let container = d3.select(this)
      , inner = container.selectAll('g.inner-arc-overlay')
                         .data(d => [d])
      , outer = container.selectAll('g.circle-ring')
                         .data(d => [d])

    inner = inner.enter()
                 .append('g')
                 .attr('class', 'inner-arc-overlay')
                 .raise()
                 .merge(inner)

    inner.selectAll('path')
         .data(d => {
          // Full arc
          return [{
            startAngle: 0,
            endAngle: 2 * Math.PI
          }]
         })
         .enter()
         .append('path')
         .attr('fill', 'url(#cycle-inner-overlay-gradient)')
         .merge(inner.selectAll('path'))
         .attr('d', d => innerArc(d))


    outer = outer.enter()
                 .append('g')
                 .attr('class', 'circle-ring')
                 .raise()
                 .merge(outer)

    outer.selectAll('path')
         .data(d => {
           // Full arc
           return [{
             clazz: 'cycle-outer-ring-upper',
             filter: 'url(#cycle-outer-ring-upper-filter)',
             clip: 'cycle-outer-ring-upper-clip',
             startAngle: -90 * Math.PI / 180,
             endAngle: 90 * Math.PI / 180
           }, {
             clazz: 'cycle-outer-ring-lower',
             filter: 'url(#cycle-outer-ring-lower-filter)',
             clip: 'cycle-outer-ring-lower-clip',
             startAngle: 90 * Math.PI / 180,
             endAngle: 270 * Math.PI / 180
           }]
         })
         .enter()
         .append('path')
         .merge(outer.selectAll('path'))
         .attr('class', d => d.clazz)
         .attr('filter', d => d.filter)
         .attr('d', d => outerArc(d))
         .attr('clip-path', d => `url(#${d.clip})`)
         .select(d => {
          let defs = d3.select(this.ownerSVGElement).selectAll('defs')
            , clip = defs.selectAll(`clipPath#${d.clip}`)
                         .data([d])
                         .enter()
                         .append('clipPath')
                           .attr('id', d.clip)
          clip.append('path')

          clip.merge(defs.selectAll(`clipPath#${d.clip}`))
              .selectAll('path')
              .attr('d', outerArc(d))
        })
  })
}

const slices = (selection, chart, arrowArc, innerArc) => {
  selection.each(function (d) {
    let container = d3.select(this)
      , range = d.block.range
      , outer = container.selectAll('g.outer-arc')
                         .data(d => [d])
      , inner = container.selectAll('g.inner-arc')
                         .data(d => [d])

    // Draw the outer arc
    outer = outer.enter()
                 .append('g')
                 .attr('class', 'outer-arc')
                 .merge(outer)

    outer.selectAll('path')
         .data(d => d.slices)
         .enter()
         .append('path')
         .attr('class', 'is-deemphasizable')
         .on('click', (e, d) => {
           if (d.data.clickable) {
             chart.ee.emit('chart-event', 'select:point', d.data, range)
           }
         })
         .merge(outer.selectAll('path'))
         .classed('deemphasize', d => d.data.deemphasize)
         .classed('is-clickable', d => d.data.clickable)
         .attr('fill', d => {
           return `url(#cycle-colored-gradient-${d.data.color})`
         })
         .attr('d', d => arrowArc(d))

    // Inner arc
    inner = inner.enter()
                 .append('g')
                 .attr('class', 'inner-arc')
                 .merge(inner)

    inner.selectAll('path')
         .data(d => d.slices)
         .enter()
         .append('path')
         .on('click', (e, d) => {
           chart.ee.emit('chart-event', 'select:point', d.data, range)
         })
         .merge(inner.selectAll('path'))
         .attr('class', d => `is-deemphasizable ${d.data.color}`)
         .classed('deemphasize', d => d.data.deemphasize)
         .attr('d', d => innerArc(d))
         .attr('fill', d => colors.lookup(d.data.color))
  })
}

export default (selection, chart, cycles, grid, config) => {
  let outerRadius = Math.min(grid.width / 2, grid.height / 2)
    , innerRadius = outerRadius * .5
    , inner = shape.arc()
                   .innerRadius(innerRadius * .8)
                   .outerRadius(innerRadius)
    , arrows = arrowArc()
                .innerRadius(innerRadius)
                .outerRadius(outerRadius)
                .indent((outerRadius - innerRadius) * .3)
    , outer = shape.arc()
                   .outerRadius(outerRadius)
                   .innerRadius(0)

  selection.each(function () {
    let container = d3.select(this)
                      .selectAll('g.cycles-container')
                      .data(cycles)
      , enter = container.enter()
                         .append('g')
                            .attr('class', 'cycles-container')

    container.exit().remove()

    container = container.merge(enter)
                         .attr('transform', d => {
                           let dim = d.dimensions
                           return `translate(${dim.width / 2 + dim.x}, ${dim.height / 2 + dim.y})`
                         })

    // Arrow arc
    container.call(slices, chart, arrows, inner)
             .call(decorations, inner, outer)
             .call(labels, arrows, config)
  })
}

